module.exports = __webpack_public_path__ + "static/media/narayana_logo.ed18f998.png";